export enum GemviewMessageType {
    IdleTablet = 1,
    SignatureCapture,
    QuestionsCapture,
    AMNClaimAccount,
    BlueEnvelopeSelection
}

export interface GemviewMessage<T> {
    type: GemviewMessageType;
    data: T;
}

export enum GemviewEvent {
    CustomWindow = 'CustomWindowEvent',
    DeviceStatus = 'GetDeviceStatusEvent',
    IdleScreen = 'LoadStartEvent',
    PushTab = 'PushCurrentTabEvent',
    Sign = 'SignStartEvent',
}

export enum GemviewResponse {
    CustomWindow = 'CustomWindowResponse',
    DeviceStatus = 'GetDeviceStatusResponse',
    Sign = 'SignResponse',
}

export enum GemviewCommand {
    CustomWindow = 'CustomSigningWindow',
    DeviceStatus = 'GetDeviceStatus',
    IdleScreen = 'LoadIdleScreen',
    PushTab = 'PushCurrentTab',
}

export enum GemviewAttribute {
    CustomWindow = 'msgAttributeCustomWindow',
    DeviceStatus = 'msgeAttributeDeviceStatus', // it's 'msge' on purpose (straight from topaz docs)
    ExtensionInstalled = 'sigplusextliteextension-installed',
    IdleScreen = 'msgeAttributeIdleScreen', // it's 'msge' on purpose (straight from topaz docs)
    Msg = 'msgAttribute',
    Sign = 'messageAttribute',
    PushTab = 'msgAttributePushCurrentTab',
}

export enum GemviewElement {
    CustomWindow = 'SignatureCaptureCustomWindow',
    DeviceStatus = 'SignatureCaptureDeviceStatus',
    IdleScreen = 'SignatureCaptureIdleScreen',
    PushTab = 'SignatureCapturePushTab',
    Sign = 'SignatureCaptureSignStart',
    Data = 'myextdataelem',
}

export interface GemviewSignResponse {
    isSigned: boolean;
    imageData: string;
    rawData: string;
    sigString: string;
    padInfo: string;
    errorMsg?: string;
}

export const METADATA = {
    EVENT_INIT_OPTIONS: { bubbles: true, cancelable: false },

    PUSH_TAB: { metadata: { version: 1.0, command: GemviewCommand.PushTab }, pushCurrentTab: true },

    DEVICE_STATUS: { metadata: { version: 1.0, command: GemviewCommand.DeviceStatus }, deviceStatus: '' },

    IDLE_SCREEN: {
        metadata: { version: 1.0, command: GemviewCommand.IdleScreen }, configurationUrl: null, duration: 500, displayLogo: false,
    },

    CUSTOM_WINDOW: {
        metadata: {
            version: 1.0,
            command: GemviewCommand.CustomWindow,
        },
        signingWindowProperties: {
            // Minimum height is 340
            signingWindow: {
                backColor: '#f0f0f0',
                // size: { width: 850, height: 500 },
                // location: { x: 130, y: 200 },
                // Window State as integer. 0 is Normal State; 2
                // is Maximized State
                windowState: 2,
                // Form Border Style as integer. 0 is None;
                // 1 is Fixed Single; 2 is Fixed 3D;
                // 3 is Fixed Dialog; 4 is Sizable
                formBorderStyle: 2,
                windowTitle: 'Sign Below',
            },
            // Minimum width is 785, Minimum height is 240
            // Height should not be more than 80% of the signing window height
            signingArea: {
                backColor: '#d3d3d3',
                // signingArea.dock: 0 is None ; 1 is Top; 2 is Bottom;
                // 3 is Left; 4 is Right; 5 is Fill.
                // Defaults to none with X and Y attributes as 0
                dock: 5,
            },
            signingWindowIconButtonsContainer: {
                backColor: '#ffffff', // --white #ffffff
                // Should not be more than 20% window height
                size: 100,
                padding: {
                    all: -1,
                    left: 0,
                    top: 0,
                    right: 1,
                    bottom: 0,
                },
                // signingWindowIconButtonsContainer.dock: 1 is Top; 2 is Bottom; 3 is Left; 4is Right.
                dock: 2,
            },
            signingWindowIconButtons: {
                backColor: '#002E5E',
                size: 90,
                margin: {
                    all: -1,
                    left: 0,
                    top: 1,
                    right: 5,
                    bottom: 2,
                },
            },
        },
    },

    SIGN_START: {
        metadata: {
            version: 1.0,
            command: 'SignatureCapture'
        },
        firstName: '',
        lastName: '',
        eMail: '',
        location: '',
        imageFormat: 1,
        imageX: 800,
        imageY: 200,
        imageTransparency: false,
        imageScaling: false,
        maxUpScalePercent: 0.0,
        rawDataFormat: 'SIG',
        minSigPoints: 25,
        penThickness: '3',
        penColor: '#000000',
        encryptionMode: '0',
        encryptionKey: 'EncryptionKey',
        sigCompressionMode: 0,
        customWindow: true,
    },
};
